export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-900 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-secondary-50 font-heading whitespace-nowrap">每日大瓜</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed mb-4">
              每日大瓜是国内领先的娱乐八卦与黑料深扒平台，聚焦最新黑料、黑历史与圈内揭底内容，每日持续更新独家猛料，为吃瓜群众打造最全最快的黑料合集。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-bold text-secondary-50 font-heading mb-4">快速导航</h3>
            <ul className="space-y-2">
              {[
                { label: '最新速报', href: '#updates' },
                { label: '吃瓜问答', href: '#faq' },
                { label: '瓜友热评', href: '#comments' },
                { label: '深扒档案', href: '#cards' },
                { label: '投稿爆料', href: '#contact' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-secondary-50 font-heading mb-4">热门分类</h3>
            <ul className="space-y-2">
              {['明星塌房', '网红翻车', '综艺内幕', '饭圈乱象', '直播争议'].map((item) => (
                <li key={item}>
                  <a href="#index" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-bold text-secondary-50 font-heading mb-4">合作伙伴</h3>
            <p className="text-sm text-secondary-500 leading-relaxed">
              合作品牌与媒体伙伴持续拓展中，欢迎优质平台与我们建立内容合作。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; 2026 每日大瓜. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-500">
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
            <a href="#contact" className="hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
            <a href="#hero" className="hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}